import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import fileIcon from "../../../assets/images/icon/fileIcon.svg";
import crossIcon from "../../../assets/images/icon/x.png";
import { useTranslation } from "react-i18next";
import { translationConstants, allowedFileTypes } from "../../../constants";

const SportTypeDocs = ({
  onFileUpload,
  isSportTypeDocsDisabled,
  isError,
  setValidationErrorMessage,
}) => {
  const { t } = useTranslation();

  const [selectedFiles, setSelectedFiles] = useState([]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (file.size > 10 * 1024 * 1024) {
          //File size exceeds 10MB, show error message
          setValidationErrorMessage(
            t(translationConstants.FILE_SIZE_LIMIT_ERROR)
          );
          return;
        }

        const fileType = file.name.split(".").pop();

        if (!allowedFileTypes.includes(`.${fileType}`)) {
          //File type is not allowed, show error message
          setValidationErrorMessage(
            t(translationConstants.FILE_TYPE_NOT_ALLOWED)
          );
          return;
        }

        setValidationErrorMessage("");
        setSelectedFiles((prevFiles) => [...prevFiles, file]);
      });

      if (onFileUpload) {
        onFileUpload(acceptedFiles);
      }
    },
    // eslint-disable-next-line
    [onFileUpload]
  );

  const removeFile = (file, event) => {
    event.stopPropagation();
    setSelectedFiles((prevFiles) => {
      const newFiles = prevFiles.filter((f) => f !== file);
      if (onFileUpload) {
        onFileUpload(newFiles);
      }
      return newFiles;
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: [".pdf", ".jpeg", ".jpg", ".png", ".svg"],
    multiple: true,
    disabled: isSportTypeDocsDisabled,
  });

  return (
    <>
      <div
        {...getRootProps()}
        className={`${
          isSportTypeDocsDisabled ? "dropzone-disabled dropzone" : "dropzone"
        }${isError ? " dotted-border" : ""}`}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the file here ...</p>
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <div className="iconDivPlus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M10.8335 4.66665C10.8335 4.20641 10.4604 3.83331 10.0002 3.83331C9.53993 3.83331 9.16683 4.20641 9.16683 4.66665V9.66665H4.16683C3.70659 9.66665 3.3335 10.0397 3.3335 10.5C3.3335 10.9602 3.70659 11.3333 4.16683 11.3333H9.16683V16.3333C9.16683 16.7935 9.53993 17.1666 10.0002 17.1666C10.4604 17.1666 10.8335 16.7935 10.8335 16.3333V11.3333H15.8335C16.2937 11.3333 16.6668 10.9602 16.6668 10.5C16.6668 10.0397 16.2937 9.66665 15.8335 9.66665H10.8335V4.66665Z"
                  fill="white"
                />
              </svg>
            </div>
            <p className="px-2">
              {t(translationConstants.dragDropClickSelectFiles)}
            </p>
          </div>
        )}
      </div>
      <ul className="FileNameCross">
        {selectedFiles.map((file, index) => (
          <li key={index}>
            <img className="fileIcon" src={fileIcon} alt="" />
            <p>{file.name}</p>
            <img
              className="crossIcon"
              onClick={(e) => removeFile(file, e)}
              src={crossIcon}
              alt=""
            />
          </li>
        ))}
      </ul>
    </>
  );
};

export default SportTypeDocs;
